import { AppTabBar } from "./components/AppTabBar";
import { BottomSheetContainer } from "./components/BottomSheet";
import { DialogContainer } from "./components/DialogStack";
import { SidebarContainer } from "./components/SidebarStack/SidebarContainer";
import { SnackbarContainer } from "./components/SnackbarStack";
import { AppLoading } from "./containers/AppLoading";
import { DynamicThemeProvider } from "./containers/DynamicThemeProvider";
import { AppRouter } from "./navigators/AppRouter";
import { ScrollToTop } from "./presentation/core/components/ScrollToTop";
import { useUser } from "./presentation/core/contexts/UserContext";
import { Tabs } from "./components/Tabs";
import useMobile from "./presentation/shared/hooks/useMobile";
import { useLocation } from "react-router-dom";
import { PullToRefresh } from "./components/PullToRefresh/PullToRefresh";
import { GlobalStyle } from "./containers/DynamicThemeProvider/GlobalStyle";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { BrokenPolicyJustificationProvider } from "./core/modules/Order/pages/OrderPage/views/OrderItem/hooks/BrokenPolicyJustificationContext";

import "leaflet/dist/leaflet.css";

function App() {
  const { isLoading } = useUser();
  const isMobile = useMobile();
  const location = useLocation();

  const shouldShowTabBar =
    isMobile && location.pathname !== "/entrar" && location.pathname !== "/redefinir-senha";

  const isProduction = import.meta.env.VITE_ENV === "prod";

  if (isLoading) return <AppLoading />;

  return (
    <DynamicThemeProvider>
      <GlobalStyle>
        <BrokenPolicyJustificationProvider>
          <PullToRefresh />
          <SidebarContainer />
          <SnackbarContainer />
          <DialogContainer />
          <BottomSheetContainer />
          <AppRouter />
          {shouldShowTabBar && (
            <Tabs defaultValue="inicio" vertical>
              <AppTabBar />
            </Tabs>
          )}
          <ScrollToTop />
        </BrokenPolicyJustificationProvider>
      </GlobalStyle>
      {!isProduction && <ReactQueryDevtools initialIsOpen={false} />}
    </DynamicThemeProvider>
  );
}

export default App;
